import { get } from "../helpers/request";
import { components } from "./api";

export const getAssets = async (address: string): Promise<components["schemas"]["Asset"][]> => {
  const res = await get<components["schemas"]["Assets"]>(`/assets?user=${address}`);
  return res.assets;
};
